import Modal from 'bf-library/Modal';
import React, { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
const ModalTrigger = memo(({ children, content, titleKey }) => {
    const handleClick = useCallback((e) => {
        e.stopPropagation();
    }, []);
    return (React.createElement(Modal, { inlineTrigger: true, trigger: (React.createElement("span", { onClick: handleClick }, children)), content: React.createElement("div", null, content), title: React.createElement(FormattedMessage, { id: titleKey, defaultMessage: titleKey }) }));
});
ModalTrigger.displayName = 'ModalTrigger';
const LegalAcceptance = memo(({ additionalConditions, termsAndConditions, privacyPolicy, }) => {
    var _a, _b;
    const hasAdditionalConditions = Object.keys(additionalConditions).length > 0 &&
        Object.values(additionalConditions).some(condition => { var _a; return ((_a = condition.description) === null || _a === void 0 ? void 0 : _a.trim()) || condition.url; });
    const hasTermsAndConditions = Boolean(((_a = termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.description) === null || _a === void 0 ? void 0 : _a.trim()) || (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.url));
    const hasPrivacyPolicy = Boolean(((_b = privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.description) === null || _b === void 0 ? void 0 : _b.trim()) || (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.url));
    const renderFallbackLink = useCallback((url) => (React.createElement("div", null,
        React.createElement(FormattedMessage, { id: "bf.informationInThisLink", defaultMessage: "bf.informationInThisLink" }),
        React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", className: "modal-link-style" },
            React.createElement(FormattedMessage, { id: "bf.thisLink", defaultMessage: "bf.thisLink" })))), []);
    const renderConditionContent = useCallback((description, url) => {
        if (description === null || description === void 0 ? void 0 : description.trim()) {
            return React.createElement("div", { dangerouslySetInnerHTML: { __html: description } });
        }
        if (url) {
            return renderFallbackLink(url);
        }
        return null;
    }, [renderFallbackLink]);
    const renderAdditionalConditionsContent = useCallback(() => {
        const filteredConditions = Object.entries(additionalConditions)
            .filter(([, conditions]) => { var _a; return ((_a = conditions.description) === null || _a === void 0 ? void 0 : _a.trim()) || conditions.url; });
        return (React.createElement(React.Fragment, null, filteredConditions.map(([key, conditions], index) => (React.createElement(React.Fragment, { key: key },
            React.createElement("div", null, renderConditionContent(conditions.description, conditions.url)),
            index < filteredConditions.length - 1 && React.createElement("hr", { className: "hr-separator" }))))));
    }, [additionalConditions, renderConditionContent]);
    const renderSingleConditionContent = useCallback((condition) => {
        if (!condition) {
            return null;
        }
        return renderConditionContent(condition.description, condition.url);
    }, [renderConditionContent]);
    const renderModalTrigger = useCallback((titleKey, content) => (React.createElement(React.Fragment, null,
        ' ',
        React.createElement(ModalTrigger, { titleKey: titleKey, content: content },
            React.createElement("span", { className: "link-style" },
                React.createElement(FormattedMessage, { id: titleKey, defaultMessage: titleKey }))))), []);
    if (!hasAdditionalConditions && !hasTermsAndConditions && !hasPrivacyPolicy) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "bf.acceptance", defaultMessage: "bf.acceptance" }),
        hasAdditionalConditions
            ? renderModalTrigger('bf.propertyConditionsLabel', renderAdditionalConditionsContent())
            : null,
        ",",
        hasTermsAndConditions
            ? renderModalTrigger('bf.generalTermsAndConditions', renderSingleConditionContent(termsAndConditions))
            : null,
        ",",
        hasPrivacyPolicy
            ? renderModalTrigger('bf.privacyPolicy', renderSingleConditionContent(privacyPolicy))
            : null,
        React.createElement("span", { className: "bf-form-element-required-asterisk" }, '. *')));
});
LegalAcceptance.displayName = 'LegalAcceptance';
export default LegalAcceptance;
// i18nLabel[bf.propertyConditionsLabel]
// i18nLabel[bf.generalTermsAndConditions]
// i18nLabel[bf.privacyPolicy]
